import { emailConstants } from '../constants/actionTypes'

const initialState = {
  isEmailProposalView: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case emailConstants.EMAIL_PROPOSAL_VIEW:
      return {
        ...state,
        isEmailProposalView: true,
      }

    default:
      return state
  }
}
